import type { PriceLogReason } from 'apis/sales-lookup';

export const REASON_LABELS: Record<PriceLogReason, string> = {
  PRICE_TOO_HIGH: 'Price too high',
  HAPPY_WITH_SUPPLIER: 'Happy with supplier',
  BRAND_PREFERENCE: 'Brand preference',
  QUALITY_CONCERN: 'Quality concern',
  JUST_RECORDING: 'Just recording',
};

const toOptions = (labels: Record<string, string>) =>
  Object.entries(labels).map(([value, label]) => ({ value, label }));

export const reasonOptions = toOptions(REASON_LABELS);
